export default class StatisticsPerAttendant {
  valor!: number;

  total!: number;

  atendenteId!: number;

  atendente!: string;
}
